export default __webpack_public_path__ + "static/media/ConversionFunction.9f9f4ed6.png";